export class ChaosSoundManager {
  private static muted = false;

  isMuted(): boolean {
    return ChaosSoundManager.muted;
  }

  toggleMuted(): boolean {
    ChaosSoundManager.muted = !ChaosSoundManager.muted;
    return ChaosSoundManager.muted;
  }
}
